import {
    RouteLocationInterface,
    RouteHttpVerb,
    RouteResponseInterface,
    RouteRequestInterface,
    RouteParamsInterface
} from "@wpnotes/utils";
import { TodoModel } from "../models";

export const locationRestTodoPut: RouteLocationInterface = {
    path: "/todo/:id",
    method: RouteHttpVerb.PUT
};

export type RequestRouteTodoPut = RouteRequestInterface;

export type ParamsRouteTodoPut = RouteParamsInterface;

export interface ResponseRouteTodoPut extends RouteResponseInterface {
    data: TodoModel[];
    errors: string[];
}
